module.exports = __webpack_public_path__ + "static/media/metamask_icon.ef0821ad.webp";